import { render, staticRenderFns } from "./RegionCrear.vue?vue&type=template&id=33a8242b&scoped=true"
import script from "./RegionCrear.vue?vue&type=script&lang=js"
export * from "./RegionCrear.vue?vue&type=script&lang=js"
import style0 from "./RegionCrear.vue?vue&type=style&index=0&id=33a8242b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8242b",
  null
  
)

export default component.exports